<pf-loading-overlay />
<div class="edit-product-event__header">
    <h3>{{ 'admin.product.event.title.editEvent' | translate }}:</h3>
</div>
@if (editProductEvent) {
    <div class="edit-product-event__container">
        <form [formGroup]="editProductEvent" (ngSubmit)="onUpdateProductEvent()">
            <div class="edit-product-event__field--event-type">
                <label>{{ 'admin.product.event.field.eventType' | translate }}:</label>
                <pf-select
                    [options]="eventTypeOptions()"
                    [initialSelectedId]="initialEventTypeId()"
                    [disabled]="true"
                    (singleSelectionChange)="onEventTypeSelect($event)"
                />
            </div>

            @if (isFieldVisible('fromStorageType')) {
                <div class="edit-product-event__field">
                    <label>{{ 'admin.product.event.field.fromStorage' | translate }}:</label>
                    <pf-select
                        [options]="storageTypeOptions()"
                        [initialSelectedId]="initialFromStorageTypeId()"
                        (singleSelectionChange)="onFromStorageTypeSelect($event)"
                    />
                </div>
            }
            @if (isFieldVisible('toStorageType')) {
                <div class="edit-product-event__field">
                    <label>{{ 'admin.product.event.field.toStorage' | translate }}:</label>
                    <pf-select
                        [options]="storageTypeOptions()"
                        [initialSelectedId]="initialToStorageTypeId()"
                        (singleSelectionChange)="onToStorageTypeSelect($event)"
                    />
                </div>
            }

            @if (isFieldVisible('productId')) {
                <div class="edit-product-event__field">
                    <label>{{ 'admin.product.event.field.productName' | translate }}:</label>
                    <pf-select
                        [options]="productSelectOptions()"
                        [initialSelectedId]="initialProductId()"
                        (singleSelectionChange)="onProductSelect($event)"
                    />
                </div>
            }

            @if (isFieldVisible('festivalId')) {
                <div class="edit-product-event__field">
                    <label>{{ 'admin.product.event.field.festivalName' | translate }}:</label>
                    <pf-select
                        [options]="festivalSelectOptions()"
                        [initialSelectedId]="initialFestivalId()"
                        (singleSelectionChange)="onFestivalSelect($event)"
                    />
                </div>
            }

            @if (isFieldVisible('partnerId')) {
                <div class="edit-product-event__field">
                    <label>{{ 'admin.product.event.field.partnerName' | translate }}:</label>
                    <pf-select
                        [options]="partnerSelectOptions()"
                        [initialSelectedId]="initialPartnerId()"
                        (singleSelectionChange)="onPartnerSelect($event)"
                    />
                </div>
            }
            @if (isFieldVisible('orderDetailsReference')) {
                <div class="edit-product-event__field">
                    <label>{{ 'admin.product.event.field.orderDetailsReference' | translate }}:</label>
                    <input
                        formControlName="orderDetailsReference"
                        name="edit-event-order-details-reference"
                        type="text"
                    />
                </div>
            }
            @if (isFieldVisible('productReference')) {
                <div class="edit-product-event__field">
                    <label>{{ 'admin.product.event.field.productReference' | translate }}:</label>
                    <input
                        formControlName="productReference"
                        name="edit-event-product-reference"
                        type="text"
                    />
                </div>
            }
            @if (isFieldVisible('quantity')) {
                <div class="edit-product-event__field">
                    <label>{{ 'admin.product.event.field.quantity' | translate }}:</label>
                    <input formControlName="quantity" name="edit-event-quantity" type="number" />
                </div>
            }
            @if (isFieldVisible('unitPrice')) {
                <div class="edit-product-event__field">
                    <label>{{ 'admin.product.event.field.unitPrice' | translate }}:</label>
                    <input formControlName="unitPrice" name="edit-event-price" type="number" />
                </div>
            }
            @if (isFieldVisible('eventDate')) {
                <div class="edit-product-event__field">
                    <label>{{ 'admin.product.event.field.eventDate' | translate }}:</label>
                    <pf-datepicker [maxDate]="maxDate" [initialDate]="existingEventDate" (selectedDate)="onEventDateSelected($event)" />
                </div>
            }
            @if (isFieldVisible('comment')) {
                <div class="edit-product-event__field">
                    <label>{{ 'admin.product.event.field.comment' | translate }}:</label>
                    <textarea cols="50" formControlName="comment" name="edit-event-comment" rows="4"></textarea>
                </div>
            }
            @if (selectedProductEventTypeOption !== null) {
                <div class="edit-product-event__form-actions">
                    <button class="edit-product-event__btn-cancel" type="button" (click)="navigateBack()">
                        <mat-icon>cancel</mat-icon>
                        {{ 'admin.product.event.button.cancel' | translate }}
                    </button>
                    <button class="edit-product-event__btn-save" type="submit" [disabled]="editProductEvent.invalid">
                        <mat-icon>save</mat-icon>
                        {{ 'admin.product.event.button.save' | translate }}
                    </button>
                </div>
            }
        </form>
    </div>
}
